/**
 * BlockEventLocation
 * @param {Object} data, content data
 * @return {Object} normalized data
 */

export const mapperEventLocation = (data: any) => {
  if (!data) {
    return null
  }
  return {
    id: data.sys?.id || '',
    sys: data.sys || null,
    contentType: data.contentType,
    venue: data.venue || '',
    city: data.city || '',
    addressLine1: data.addressLine1 || '',
    addressLine2: data.addressLine2 || '',
    addressLine3: data.addressLine3 || '',
    addressLine4: data.addressLine4 || ''
  }
}
